(function () {
    // Only initialize after consent is granted
    // Replace this check with your actual OneTrust consent logic
    var hasConsent = true; // ← swap this out for your real consent check later

    if (!hasConsent) return;

    // Initialize the engage variable
    var engage;

    // Inject the Engage SDK script tag
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://d1mj578wat5n4o.cloudfront.net/sitecore-engage-v.1.4.3.min.js";
    var x = document.querySelector("script");
    x.parentNode.insertBefore(s, x);

    // Initialize once the script has loaded
    s.addEventListener("load", async function () {

        var settings = {
            clientKey: "3028f42532288445e0f07952e019973f",           // ← from Personalize portal
            targetURL: "https://api-engage-us.sitecorecloud.io", // ← confirmed from your portal
            pointOfSale: "conmed-nonprod",             // ← the Point of Sale you create
            cookieDomain: ".conmed.com",                // ← top-level domain
            cookieExpiryDays: 365,
            forceServerCookieMode: false,
            includeUTMParameters: true,
            webPersonalization: true                          // ← REQUIRED for Web Experiences
        };

        engage = await window.Engage.init(settings);

        // Fire a VIEW event on every page load
        engage.pageView({
            channel: "WEB",
            language: document.documentElement.lang || "EN",
            currency: "USD",
            pointOfSale: settings.pointOfSale,
            page: window.location.href
        });

        // Expose engage globally so Web Experience templates can access it
        window.engage = engage;

    });
})();